var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"project-view",attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"column":"","align-center":"","justify-center":""}},[_c('h2',[_vm._v("Project content not uploaded")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }